import React from 'react';
import PropTypes from 'prop-types';

// Style and SEO
import { Col, Grid, Row, styled, th, up, css } from '@smooth-ui/core-sc';
import Helmet from 'react-helmet';
import { userProfileRequest } from '_platform/src/containers/App/actions';
import { selectUserProfile } from '_platform/src/containers/App/selectors';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
// import LoadingAnimation from '_platform/src/components/Loading/LoadingAnimation';

import { withSettings } from '../../containers/WebApp/SettingsContext';
import PrivateComponent from '_platform/src/utils/PrivateComponent';
import HomeBanner from 'components/CustomComponents/Banners/HomeBanner';

import Icon1 from './images/Icon1@2x.png';
import Icon2 from './images/Icon2@2x.png';
import Icon3 from './images/Icon3@2x.png';
// import Icon4 from './images/Icon4@2x.png';
import Icon5 from './images/Icon5@2x.png';

import TimedComponent from 'components/TimedComponent/TimedComponent';

const NoticeContainer = styled.div`
  background-color: ${th('primary')};
  padding: 1em;

  ${up(
    'md',
    css`
      padding: 2em;
    `
  )};
`;

//import LoadAsync from '_platform/src/utils/LoadAsync';
//const StatementProvider = LoadAsync(() =>
//  import(
//    /* webpackChunkName: "statementProvider" */ '../StatementProvider/StatementProvider'
//  )
//);
//const GatewayGraph = LoadAsync(() =>
//  import(
//    /* webpackChunkName: "gatewayGraph" */ '../../components/StatementGateway/GatewayGraph'
//  )
//);

/*const StatementStyles = styled.div`
  text-align: center;

  section:not(:last-of-type) {
    border-bottom: 1px solid ${thd('statementHighlightColor', '#f4bd19')};
    padding-bottom: 1.25rem;
  }

  .incentive-tiers {
    border: 2px solid ${thd('primary', '#000')};
    margin-top: 1em;
    padding: 0.5em;
  }

  .incentive-tiers-targets {
    display: flex;
    justify-content: space-around;
  }

  .statement-legend {
    margin-bottom: 2em;
  }

  .client-target-container {
    margin: 1em 0;
  }

  .client-buying-period {
    background-color: ${thd('primary', '#000')};
    color: #fff;
    margin: 0.5em 0;
    padding: 0.5em 0.25em;
  }

  .client-target-selection {
    margin: 0 auto;
    max-width: 420px;
  }
`;

const fetchStatements = [
  {
    endpoint: '/Statement/v1/Loyalty/Pending',
    section: 'loyalty',
  },
  {
    endpoint: '/Statement/v1/Epson/Gateway/',
    section: 'incentive',
  },
];*/

/*const WhatsNewList = styled.ul`
  list-style-position: inside;
`;*/

const HomePage = ({ settings, userProfile }) => {
  return (
    <div>
      <Helmet>
        {/* <meta name="description" content="Page description" /> */}
      </Helmet>

      <PrivateComponent
        redirectOnError={{
          pathname: settings.settingsApp.loginPagePath || '/login/',
        }}
      >
        <HomeBanner
          pageTitle={
            <React.Fragment>
              <h2 className="text--uppercase">
                Welcome{' '}
                {userProfile && userProfile.data && userProfile.data.firstName}{' '}
                to
                <br />
                Epson Premium Partner Rewards
              </h2>
            </React.Fragment>
          }
        />

        <Grid>
          {/*<Row justifyContent="center">
            <Col xs={12} md={6} className="text--center">
              <PrivateComponent displayError>
                <StatementStyles>
                  <StatementProvider
                    fetch={fetchStatements}
                    render={({ statement }) => {
                      return !statement ||
                        !statement.data ||
                        !statement.data.incentive ? (
                        <LoadingAnimation /> // Loader instead of `null`?
                      ) : (
                        <GatewayGraph
                          gatewayTarget={statement.data.incentive}
                        />
                      );
                    }}
                  />
                </StatementStyles>
              </PrivateComponent>
            </Col>
          </Row>
          <Row justifyContent="center">
            <Col md={12} className="text--center">
              <h3 className="text--uppercase">What’s new?</h3>
              <WhatsNewList>
                <li>
                  Removal of Gateway Targets. On claim approval, you will earn
                  rewards points that can be instantly spent.
                </li>
                <li>
                  Seamless speedy claim approval. Your claims are approved
                  faster than ever. This means your points balance will grow
                  even faster.{' '}
                </li>
                <li>
                  More flexible rewards with Aspire Rewards. Check out the
                  'Aspire' page. Anything is possible!
                </li>
              </WhatsNewList>
            </Col>
          </Row>*/}
          <Row justifyContent="center">
            <Col md={8} className="text--center">
              <TimedComponent start="01-04-2024">
                <NoticeContainer>
                  <h3 className="text--uppercase">
                    The 2026-27 Program
                    <br />
                    has launched!
                  </h3>
                  <p>
                    The program runs from <b>1st May 2026 - 28th Feb 2027</b>.
                  </p>
                  <p>
                    Claims can be backdated to sales made from{' '}
                    <b>1st April 2026</b>.
                  </p>
                  <p>
                    Your points will be redeemable up to <b>31st March 2027</b>.
                  </p>
                </NoticeContainer>
              </TimedComponent>
              <h3 className="text--uppercase">How it works</h3>
              <p>Want More Rewards? Sell More Epson.</p>
              <p>
                For every eligible Epson product you sell, you'll earn valuable
                rewards points. Simply lodge your sales on the "Claims" page and
                watch your points balance grow! Browse our exclusive range of
                products on the "Catalogue" page to redeem your points
                instantly.
              </p>
            </Col>
          </Row>
          <Row justifyContent="center" className="spacer--large">
            <Col xs={6} md={4} lg={2} className="text--center">
              <img src={Icon1} alt="SALES" width="118" />
              <h4 className="text--uppercase">SALES</h4>
              <p>
                Sell eligible
                <br />
                Epson products
              </p>
            </Col>
            <Col xs={6} md={4} lg={2} className="text--center">
              <img src={Icon2} alt="CLAIM" width="118" />
              <h4 className="text--uppercase">CLAIM</h4>
              <p>
                Submit your
                <br />
                sales claim
              </p>
            </Col>
            <Col xs={6} md={4} lg={2} className="text--center">
              <img src={Icon3} alt="EARN" width="118" />
              <h4 className="text--uppercase">EARN</h4>
              <p>
                Earn rewards
                <br />
                points
              </p>
            </Col>
            <Col xs={6} md={4} lg={2} className="text--center">
              <img src={Icon5} alt="REDEEM" width="118" />
              <h4 className="text--uppercase">REDEEM</h4>
              <p>
                Redeem your
                <br />
                points for rewards!
              </p>
            </Col>
          </Row>
        </Grid>
      </PrivateComponent>
    </div>
  );
};

HomePage.propTypes = {
  onUserProfileRequest: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
  userProfile: PropTypes.object,
};

HomePage.defaultProps = {
  userProfile: undefined,
};

const mapStateToProps = createStructuredSelector({
  userProfile: selectUserProfile(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onUserProfileRequest: () => dispatch(userProfileRequest()),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withSettings, withConnect)(HomePage);
